export default {
  tagline: "Популярна карткова гра онлайн. 🕵️‍♂️",
  "create-game": "Створити гру",
  "new-game": "нова гра",
  "back-to-lobby": "назад до лобі",
  "join-room": "Приєднатися",
  "no-public-room":
    "Зараз немає загальнодоступних ігор. Створіть гру та запросіть друзів!",
  "how-to-play": "Як грати",
  "game-tagline":
    "Кодові імена — це гра на вгадування, де команди змагаються, щоб знайти слова, пов’язані з підказкою іншого гравця.",
  "see-more": "Ще...",
  "classic-rules": "Правила: Класика",
  "duet-rules": "Правила: Дует",
  "support-authors":
    "Якщо вам сподобалася ця гра, будь ласка, підтримайте авторів і придбайте паперову версію!",
  "made-with-love": "Зроблено з ♥ під час карантину",
  "its-open-source": "Це <1>open-source</1>.",
  "check-our-privacy-policy":
    "Ознайомтеся з нашою <2>політикою конфіденційності</2>.",
  "choose-options": "Параметри гри",
  "custom-words-placeholder": "складніше, краще, швидше, сильніше",
  "custom-words-warning":
    "Вам потрібно щонайменше 25 слів, щоб грати лише зі своїми словами.",
  "custom-words-checkbox": "Об’єднати зі словником",
  "custom-words-notice":
    "Введіть список користувацьких слів, розділених комами. Зніміть прапорець нижче, щоб використовувати лише ці слова",
  advanced: "розширити...",
  "custom-words": "Користувацькі слова",
  mode: "Pежим",
  duet: "Дует",
  classic: "Класика",
  dictionary: "Словник",
  "public-game": "Загальнодоступна гра",
  private: "Приватна",
  public: "Загальнодоступна",
  "join-game": "Приєднатися",
  "placeholder-join": "приєднайтеся до гри, щоб почати спілкуватися",
  "give-hint": "підказка",
  "clicked-on": "Обрав(ла)",
  "become-spymaster": "Стати капітаном",
  "switch-teams": "Змінити команди",
  "red-adj": "червоні",
  "blue-adj": "сині",
  "start-game-classic":
    "Капітан команди <1>{{team}}</1> дає підказку, щоб розпочати гру!",
  "see-rules": "Правила",
  "start-game-duet": "Натисніть на карту або дайте підказку, щоб розпочати гру!",
  "copied-to-clipboard": "Скопійовано в буфер обміну!",
  "turns-left": "Залишилося {{ count }} ходів",
  "turns-left_plural": "Залишилося {{ count }} ходів",
  "game-over": "Гру завершено.",
  "winner-team": "Команда <1>{{team}}</1> перемагає!",
  "black-card-loss": "Ви програли, бо натиснули на чорну карту.",
  "out-of-time-loss": "У вас закінчився час!",
  won: "Ви виграли!",
  "join-red": "приєднатися до червоних",
  "join-blue": "приєднатися до синіх",
  "join-side": "приєднатися",
  spectate: "спостерігати",
  "game-started": "у процесі",
  "page-title": "Кодові імена — Грати онлайн",
  "page-description":
    "Грайте в Кодові імена онлайн — багатокористувацьку гру в слова, доступну на телефоні та комп’ютері. У цій асоціативній грі команди змагаються, щоб знайти карти, пов’язані з підказкою.",
  "in-the-room": "У кімнаті",
  rules: "Правила",
  red: "Червоні",
  blue: "Сині",
  duetA: "Сторона A",
  duetB: "Сторона B",
  spectator: "Спостерігачі",
  "just-joined": "приєднався(лася) до гри!",
  "game-created": "Гру створено.",
  "no-players-yet": "У цій грі поки нікого немає!",
  "player-name-placeholder": "ім’я гравця",
  cards: "слів",
  buymeacoffee: "Підтримайте гру — купіть мені каву",
  "positive-reaction-1": "Чудово!",
  "positive-reaction-2": "Гарна робота!",
  "positive-reaction-3": "Сильний хід.",
  "positive-reaction-4": "Одне очко!",
  "positive-reaction-5": "Так!",
  "positive-reaction-6": "😎",
  "neutral-reaction-1": "Повз.",
  "neutral-reaction-2": "Досить близько.",
  "neutral-reaction-3": "Пощастить іншим разом.",
  "neutral-reaction-4": "Це був мирний житель.",
  "neutral-reaction-5": "Майже!",
  "neutral-reaction-6": "Не надто вдало.",
  "black-reaction-1": "Ви щойно програли!",
  "black-reaction-2": "Інша команда перемагає!",
  "black-reaction-3": "Ваша команда програє ☠️",
  "black-reaction-4": "О ні, ви обрали вбивцю ☠️",
  "negative-reaction-1": "Упс!",
  "negative-reaction-2": "О ні!",
  "negative-reaction-3": "Інша команда вам вдячна.",
  "negative-reaction-4": "Не хвилюйтеся, ви старалися як могли 💛.",
  "negative-reaction-5": "🤦‍♂️",
  "long-story-short": "Коротко кажучи",
  "privacy-tldr": `
  <p>Ми зберігаємо ігри та чати в нашій базі даних протягом певного часу, але вони можуть бути видалені в будь-який момент. Це єдина інформація, яку ми зберігаємо.</p>
  <p>Ми використовуємо cookies для перегляду аналітики використання сайту (демографія, тривалість сесій, типи ігор). Ця аналітика не містить особистої інформації.</p>
  <p>Наш постачальник аналітики — Google Analytics.</p>
`,
};